(function () {
  'use strict';

  /* ── Sticky toolbar top offset ──────────────────────────────────────────
     The Kalles theme initialises --header-height: 0px in base.css and then
     updates it via JS. Our fallback (64px) therefore never fires - the toolbar
     sticks at top:0 and clips over the header until the theme JS fires.
     Fix: measure the actual sticky header element and set --kc-toolbar-top. */
  function setToolbarTop() {
    /* India parity, measured 2026-08-28: on India none of this function's
       header selectors ever matched, so the toolbar has always shipped at
       top:0 - on scroll it tucks cleanly under the sticky header. Here the
       selector DID match and measured the UN-scrolled header (~110px), while
       the scrolled header compacts to ~62px - a 48px gap with the grid
       showing through it (owner screenshot). Pin at 0 like India. */
    var toolbar = document.querySelector('.kc__toolbar');
    if (!toolbar) return;
    toolbar.style.setProperty('--kc-toolbar-top', '0px');
  }
  /* Run immediately + after any resize (orientation change etc.) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setToolbarTop);
  } else {
    setToolbarTop();
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setToolbarTop, 120);
  });

  /* All handlers are delegated on `document` so they survive the HDT
     facet:render re-render, which replaces the [main-content] subtree. */

  /* ── Hero "i" info button - tap-toggle the centred description dialog ────
     The panel is a viewport-centred overlay (see kitsters-collection.css), so
     it opens on click/tap only - there is no CSS hover/focus reveal any more.
     Closes on the X, on the backdrop, on a click outside, and on Escape.
     The hero lives outside [main-content] so it isn't re-rendered, but
     delegation is harmless. */
  function focusSafe(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  }
  function closeInfoWrap(wrap, refocus) {
    if (!wrap || !wrap.classList.contains('is-open')) return;
    wrap.classList.remove('is-open');
    var b = wrap.querySelector('[data-kc-info]');
    if (!b) return;
    b.setAttribute('aria-expanded', 'false');
    if (refocus) focusSafe(b);
  }
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var btn = target.closest('[data-kc-info]');
    if (btn) {
      var wrap = btn.closest('[data-kc-info-wrap]');
      if (wrap) {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        /* Move focus into the dialog on open so keyboard + screen-reader users
           land on it; closing hands focus back to the trigger. */
        if (open) focusSafe(wrap.querySelector('[data-kc-info-close-btn]'));
      }
      return;
    }

    /* The X button and the backdrop both sit INSIDE the wrap, so the
       click-outside pass below can never see them - handle them explicitly. */
    var closer = target.closest('[data-kc-info-close]');
    if (closer) {
      closeInfoWrap(closer.closest('[data-kc-info-wrap]'), true);
      return;
    }

    /* Click outside any open dialog closes it. */
    var openWraps = document.querySelectorAll('[data-kc-info-wrap].is-open');
    for (var i = 0; i < openWraps.length; i++) {
      if (!openWraps[i].contains(target)) closeInfoWrap(openWraps[i], false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openWraps = document.querySelectorAll('[data-kc-info-wrap].is-open');
    for (var i = 0; i < openWraps.length; i++) closeInfoWrap(openWraps[i], true);
  });

  /* ── Sort: update sort_by, preserving any active filter params ──────────
     Uses the Section Rendering API (?sections=<id>) to swap just the
     [main-content] subtree - no full page reload - matching the same
     target the HDT facet:render system replaces on filter change.
     Any failure (network, parse, unsupported) falls back to a full nav so
     sorting always works. */
  var sortInFlight = false;
  function ajaxSort(url, sel) {
    var main = document.querySelector('.kc [main-content]');
    if (!main || !main.id || !window.DOMParser || !main.replaceWith) {
      window.location.href = url.toString();
      return;
    }
    var sectionId = main.id;
    var section = main.closest('.kc') || main.parentElement;
    var fetchUrl = url.pathname + url.search + '&sections=' + encodeURIComponent(sectionId);
    sortInFlight = true;
    if (section) section.setAttribute('loading', '');
    if (sel) sel.disabled = true;
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('sort fetch failed'); return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) throw new Error('section missing in payload');
        var newMain = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[main-content]');
        if (!newMain) throw new Error('main-content missing in payload');
        main.replaceWith(newMain);
        /* replaceState (not push) keeps sort_by in the URL so a subsequent HDT
           filter request preserves the sort, without adding a history entry
           that would race the HDT facet popstate handler. */
        history.replaceState({ kcSort: true }, '', url.toString());
        setToolbarTop();
        var toolbar = document.querySelector('.kc__toolbar');
        if (toolbar) toolbar.scrollIntoView({ block: 'start', behavior: 'smooth' });
      })
      .catch(function () { window.location.href = url.toString(); })
      .finally(function () {
        sortInFlight = false;
        if (section) section.removeAttribute('loading');
      });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-kc-sort]');
    if (!sel || sortInFlight) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    ajaxSort(url, sel);
  });

  /* ── Click delegation: ATC, wishlist, recently-viewed capture ── */
  document.addEventListener('click', function (e) {
    var kc = e.target.closest('.kc');
    if (!kc) return;

    /* Add to cart - scoped strictly to the button itself; never let this
       bubble into a card's own <a> navigation (image/title links). */
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(addBtn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      addBtn.disabled = true;
      var savedHTML = addBtn.innerHTML;
      addBtn.innerHTML = '&hellip;';

      /* KitstersCart owns the drawer contract (assets/kitsters-cart-bridge.js).
         This used to read a `section-id` ATTRIBUTE off the drawer and dispatch
         `cart:update` with {cartData, source:'product-form-component',
         actionAfterATC} -- the KALLES contract, ported from India and never
         adapted. Dawn's <cart-drawer> has neither the attribute nor the
         listener, so `sectionId` was always null and the first branch never
         ran; the `cart:reload` fallback below it dispatched an event NOTHING in
         this tree listens for, so it was equally dead. Net effect: the item was
         added, the drawer kept its page-load HTML, and only a page refresh
         showed it. Root CLAUDE.md §10.21 -- never hand-roll an ATC handler. */
      var payload = { items: [{ id: variantId, quantity: 1 }] };

      window.KitstersCart.addToCart(payload)
      .then(function () {
        addBtn.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> Added!';
        setTimeout(function () { addBtn.disabled = false; addBtn.innerHTML = savedHTML; }, 2000);
      })
      .catch(function () { addBtn.disabled = false; addBtn.innerHTML = savedHTML; });
      return;
    }

    /* Wishlist toggle */
    var wishBtn = e.target.closest('[data-wishlist]');
    if (wishBtn) { wishBtn.classList.toggle('is-on'); return; }

    /* Recently-viewed capture - record the product the user clicks into.
       Whole-card click (kitsters-card-click.js) means a shopper can now enter
       a product from the card's dead space, not only from a link, so a card
       carrying data-card-link counts as a navigation too. The add-to-cart and
       wishlist branches above already returned, so anything reaching here is
       genuinely a click through to the product. */
    var card = e.target.closest('article.product[data-rv-url]');
    if (card && (e.target.closest('a[href]') || card.hasAttribute('data-card-link'))) {
      try {
        var rv = JSON.parse(localStorage.getItem('kitsters_rv') || '[]');
        var entry = {
          url:   card.getAttribute('data-rv-url'),
          title: card.getAttribute('data-rv-title'),
          price: card.getAttribute('data-rv-price'),
          image: card.getAttribute('data-rv-image')
        };
        rv = rv.filter(function (p) { return p.url !== entry.url; });
        rv.unshift(entry);
        if (rv.length > 12) rv = rv.slice(0, 12);
        localStorage.setItem('kitsters_rv', JSON.stringify(rv));
      } catch (err) {}
    }
  });

  /* ── Render Recently Viewed from a prior session (runs once on load) ── */
  function renderRecentlyViewed() {
    var wrap = document.querySelector('[id^="kc-recently-"]');
    var grid = document.querySelector('[id^="kc-rv-grid-"]');
    if (!wrap || !grid) return;

    var onPage = new Set();
    document.querySelectorAll('.kc [data-rv-url]').forEach(function (el) {
      onPage.add(el.getAttribute('data-rv-url'));
    });

    var stored;
    try { stored = JSON.parse(localStorage.getItem('kitsters_rv') || '[]'); }
    catch (err) { return; }

    var toShow = stored.filter(function (p) { return p.url && !onPage.has(p.url); }).slice(0, 6);
    if (toShow.length < 3) return; /* not enough history to be worth showing */

    var frag = document.createDocumentFragment();
    toShow.forEach(function (p) {
      var article = document.createElement('article');
      article.className = 'product';
      /* Whole card opens the product - same contract as the Liquid card. */
      if (p.url) article.setAttribute('data-card-link', p.url);
      var imgEl = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy" width="400" height="400" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover">'
        : '<div style="position:absolute;inset:0;background:#f5f5f5;display:flex;align-items:center;justify-content:center;font-size:40px">🎨</div>';
      var a = document.createElement('a');
      a.href = p.url; a.className = 'product__media';
      a.style.cssText = 'display:block;text-decoration:none';
      a.innerHTML = imgEl;
      var body = document.createElement('div');
      body.className = 'product__body';
      var h3 = document.createElement('h3');
      h3.className = 'product__name';
      var titleLink = document.createElement('a');
      titleLink.href = p.url; titleLink.style.cssText = 'color:inherit;text-decoration:none';
      titleLink.textContent = p.title || '';
      h3.appendChild(titleLink);
      var priceRow = document.createElement('div');
      priceRow.className = 'product__priceRow';
      var price = document.createElement('span');
      price.className = 'product__price';
      price.textContent = p.price || '';
      priceRow.appendChild(price);
      var view = document.createElement('a');
      view.href = p.url; view.className = 'product__add';
      view.style.textDecoration = 'none';
      view.innerHTML = 'View Kit <i class="ph ph-arrow-right" aria-hidden="true"></i>';
      body.appendChild(h3); body.appendChild(priceRow); body.appendChild(view);
      article.appendChild(a); article.appendChild(body);
      frag.appendChild(article);
    });
    grid.appendChild(frag);
    wrap.style.display = '';
    wrap.removeAttribute('aria-hidden');
    /* Only after the band is visible - the track measures 0x0 while its
       ancestor is display:none, so an overflow check before this point
       always says "no overflow" and permanently hides the arrows. */
    initRecentlyViewedRail(wrap, grid);
  }

  /* ── Recently Viewed rail - prev/next over the horizontal track ──────────
     The track is a plain overflow-x scroller, so swipe/trackpad/keyboard
     already work with no JS at all; this only adds the desktop arrows and
     keeps their state honest. Arrows stay hidden unless the track really
     overflows - with 3 cards on a wide screen there is nothing to scroll. */
  function initRecentlyViewedRail(wrap, track) {
    var nav = wrap.querySelector('[data-kc-rv-nav]');
    var prev = wrap.querySelector('[data-kc-rv-prev]');
    var next = wrap.querySelector('[data-kc-rv-next]');
    if (!nav || !prev || !next) return;

    /* One card + one gap. Read from the DOM rather than hardcoded, because the
       card width is a clamp() that changes at every viewport width. */
    function stepSize() {
      var card = track.querySelector('.product');
      if (!card) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 4) { nav.hidden = true; return; }
      nav.hidden = false;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByStep(dir) {
      var left = dir * stepSize();
      if (track.scrollBy) track.scrollBy({ left: left, behavior: 'smooth' });
      else track.scrollLeft += left;
    }

    prev.addEventListener('click', function () { scrollByStep(-1); });
    next.addEventListener('click', function () { scrollByStep(1); });
    track.addEventListener('scroll', update, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecentlyViewed);
  } else {
    renderRecentlyViewed();
  }

  /* ── "Show More Products" - progressive load-more ────────────────────────
     Fetches the next paginated page via the Section Rendering API and
     appends its .kc__cell nodes to the existing grid. The noscript numbered
     pagination in the Liquid is the real, crawlable fallback if this never
     runs (JS disabled/failed) - this handler only enhances that baseline. */
  var loadMoreInFlight = false;
  function handleLoadMore(btn) {
    if (loadMoreInFlight) return;
    var wrap = btn.closest('[data-kc-loadmore]');
    if (!wrap) return;
    var main = btn.closest('.kc [main-content]');
    var grid = main && main.querySelector('.kc__grid');
    if (!main || !grid) return;

    var sectionId = main.id;
    var baseUrl = wrap.getAttribute('data-url') || window.location.pathname;
    var nextPage = parseInt(wrap.getAttribute('data-current-page'), 10) + 1;
    var totalPages = parseInt(wrap.getAttribute('data-total-pages'), 10);

    var url = new URL(baseUrl, window.location.origin);
    url.search = window.location.search;
    url.searchParams.set('page', nextPage);
    var fetchUrl = url.pathname + url.search + '&sections=' + encodeURIComponent(sectionId);

    loadMoreInFlight = true;
    var savedHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '&hellip;';

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('load more fetch failed'); return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) throw new Error('section missing in payload');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.kc__grid');
        if (!newGrid) throw new Error('grid missing in payload');

        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(newGrid.children, function (cell) { frag.appendChild(cell); });
        grid.appendChild(frag);

        wrap.setAttribute('data-current-page', nextPage);

        if (nextPage >= totalPages) {
          btn.remove();
        } else {
          btn.disabled = false;
          btn.innerHTML = savedHTML;
        }
      })
      .catch(function () {
        /* Fail safe: send the user to the real paginated URL rather than
           leaving a dead button. */
        window.location.href = url.toString();
      })
      .finally(function () { loadMoreInFlight = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kc-loadmore-btn]');
    if (btn) handleLoadMore(btn);
  });

  /* ── "Shop by Categories" slider ─────────────────────────────────────── */

  /* Toggle .kcs--fade-left / .kcs--fade-right on the wrapper div.
     CSS ::before / ::after pseudo-elements on the wrapper show the gradient
     overlays - no mask-image involved, so there are zero vendor-prefix quirks.
     The wrapper starts with neither class, so both overlays are hidden (opacity:0)
     by default - the left fade is structurally absent until JS explicitly adds it.
     Tolerance is 8px (not 2) to handle sub-pixel snap positions and smooth-scroll
     overshoot on all browsers. scrollend (modern) provides a final accurate check
     after smooth-scroll animations complete. */
  function updateKcsFade(track) {
    var wrap = track.closest('[data-kcs-wrap]');
    if (!wrap) return;
    var atStart = track.scrollLeft <= 8;
    var atEnd = Math.round(track.scrollLeft + track.clientWidth) >= Math.round(track.scrollWidth) - 8;
    wrap.classList.toggle('kcs--fade-left',  !atStart);
    wrap.classList.toggle('kcs--fade-right', !atEnd);
  }

  /* JioHotstar-style centre-focused "coverflow" (mobile only, < 768px).
     For each card, scale + opacity are driven continuously by how far the
     card's centre sits from the track's viewport centre - so cards slide,
     scale and crossfade under the finger and snap into place. The card
     nearest the centre gets .kcs__card--active for the full comic border.
     At ≥768px (or with reduced-motion) the effect is off and any inline
     vars are cleared, so the desktop row is left exactly as before. */
  var kcsMobile = window.matchMedia('(max-width: 767px)');
  var kcsReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateKcsCoverflow(track) {
    var cards = track.querySelectorAll('.kcs__card');
    if (!kcsMobile.matches || kcsReduce.matches) {
      cards.forEach(function (card) {
        card.style.removeProperty('--kcs-scale');
        card.style.removeProperty('--kcs-op');
        card.classList.remove('kcs__card--active');
      });
      return;
    }
    var rect = track.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var half = rect.width / 2 || 1;
    var nearest = null, nearestDist = Infinity;
    cards.forEach(function (card) {
      var cr = card.getBoundingClientRect();
      var cardCenter = cr.left + cr.width / 2;
      var dist = Math.abs(center - cardCenter);
      var ratio = Math.min(dist / half, 1); /* 0 at centre → 1 at the edge */
      card.style.setProperty('--kcs-scale', (1 - ratio * 0.16).toFixed(3));
      card.style.setProperty('--kcs-op', (1 - ratio * 0.5).toFixed(3));
      if (dist < nearestDist) { nearestDist = dist; nearest = card; }
    });
    cards.forEach(function (card) {
      card.classList.toggle('kcs__card--active', card === nearest);
    });
  }

  function updateKcsTrack(track) { updateKcsFade(track); updateKcsCoverflow(track); }

  function initKcsTrack(track) {
    /* Measure inside rAF so layout (including image intrinsic sizes) is stable */
    requestAnimationFrame(function () { updateKcsTrack(track); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { updateKcsTrack(track); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    /* scrollend fires once the smooth-scroll animation has fully settled - gives
       an accurate final reading that the rAF-debounced scroll handler may miss. */
    track.addEventListener('scrollend', function () { updateKcsTrack(track); }, { passive: true });
  }

  function refreshAllKcs() {
    document.querySelectorAll('[data-kcs-track]').forEach(updateKcsTrack);
  }

  document.querySelectorAll('[data-kcs-track]').forEach(initKcsTrack);

  /* Re-run after all resources load - image load changes scrollWidth */
  window.addEventListener('load', refreshAllKcs);

  /* Re-run on bfcache restore (back/forward navigation) so scroll restoration
     doesn't leave a stale fade state. */
  window.addEventListener('pageshow', refreshAllKcs);

  /* Re-run on resize / breakpoint change so crossing 768px cleanly enables or
     clears the mobile coverflow transforms. */
  window.addEventListener('resize', refreshAllKcs, { passive: true });

  /* Arrow clicks */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-kcs-prev]');
    var next = e.target.closest('[data-kcs-next]');
    if (!prev && !next) return;
    var stage = (prev || next).closest('.kcs__stage');
    var track = stage && stage.querySelector('[data-kcs-track]');
    if (!track) return;
    var firstCard = track.querySelector('.kcs__card');
    var gap = parseInt(window.getComputedStyle(track).columnGap, 10) || 14;
    var scrollAmt = firstCard ? firstCard.offsetWidth + gap : 240;
    track.scrollBy({ left: prev ? -scrollAmt : scrollAmt, behavior: 'smooth' });
  });

  /* ══ Filter drawer - theme-side facet engine ═══════════════════════════
     Shopify's native faceting is not usable here: only Price is configured in
     Search & Discovery, the theme cannot add filters, and unconfigured
     `filter.*` params are silently ignored by the server (measured). So the
     section renders the WHOLE collection (paginate by 250) with each product's
     facet values stamped on its cell, and this engine filters that.

     State lives in the query string under `kf_*` so a filtered view is
     shareable and survives back/forward. Liquid cannot read those params -
     only this file does - which is why the chips, badge and counts are all
     rendered here rather than server-side. */

  var KF_GROUPS = ['for', 'kit', 'price', 'rating', 'time'];
  var KF_FLAGS = ['stock', 'sale'];
  var KF_LABELS = {
    'for-you': 'Just me', 'for-couples': 'Couples', 'for-families': 'Family',
    'girls-night': "Friends' Night", 'corporate': 'Team',
    'stock': 'In stock', 'sale': 'On sale'
  };
  var kfState = null;
  var kfShown = 0;
  var kfApplying = false;

  function kfGrid() { return document.querySelector('[data-kc-grid]'); }
  function kfBatch() {
    var g = kfGrid();
    var n = g ? parseInt(g.getAttribute('data-kc-batch'), 10) : 0;
    return n > 0 ? n : 24;
  }

  /* Parse a cell's stamped facet values. Blank/absent means "unknown", which
     must never match a facet - a product with no duration is not "under 30
     min". Kept as an explicit null rather than 0 so the distinction survives. */
  function kfCell(el) {
    var d = el.getAttribute.bind(el);
    var r = parseFloat(d('data-r'));
    var m = parseInt(d('data-m'), 10);
    return {
      el: el,
      p: parseInt(d('data-p'), 10) || 0,
      /* Space-separated list, like `f` below: the metafield's own type plus
         any title-derived secondary types (festive/fashion/food/garden) the
         section stamped - see the facet-data block in kitsters-collection
         .liquid. A single value here is why Festive matched 2 products while
         the Ganpati kit sat unfindable under Craft (owner report 2026-08-16). */
      k: (d('data-k') || '').split(' ').filter(Boolean),
      r: isNaN(r) ? null : r,
      m: isNaN(m) ? null : m,
      a: d('data-a') === '1',
      s: d('data-s') === '1',
      f: (d('data-f') || '').split(' ').filter(Boolean)
    };
  }

  function kfReadUrl() {
    var q = new URLSearchParams(window.location.search);
    var st = { min: '', max: '' };
    KF_GROUPS.concat(KF_FLAGS).forEach(function (g) {
      var v = q.get('kf_' + g);
      st[g] = v ? v.split(',').filter(Boolean) : [];
    });
    st.min = q.get('kf_min') || '';
    st.max = q.get('kf_max') || '';
    return st;
  }

  function kfWriteUrl() {
    var q = new URLSearchParams(window.location.search);
    KF_GROUPS.concat(KF_FLAGS).forEach(function (g) {
      if (kfState[g] && kfState[g].length) q.set('kf_' + g, kfState[g].join(','));
      else q.delete('kf_' + g);
    });
    if (kfState.min) q.set('kf_min', kfState.min); else q.delete('kf_min');
    if (kfState.max) q.set('kf_max', kfState.max); else q.delete('kf_max');
    var s = q.toString();
    window.history.replaceState({}, '', window.location.pathname + (s ? '?' + s : ''));
  }

  function kfActiveCount() {
    var n = 0;
    KF_GROUPS.concat(KF_FLAGS).forEach(function (g) { n += (kfState[g] || []).length; });
    if (kfState.min || kfState.max) n += 1;
    return n;
  }

  /* Does a cell satisfy every group except `skip`? Within a group the selected
     values are OR'd; groups are AND'd - the conventional faceting contract, and
     what makes the per-option counts below mean "how many you'd get if you also
     ticked this". */
  function kfMatch(c, skip) {
    var st = kfState;
    if (skip !== 'for' && st['for'].length &&
        !st['for'].some(function (v) { return c.f.indexOf(v) > -1; })) return false;
    if (skip !== 'kit' && st.kit.length &&
        !st.kit.some(function (v) { return c.k.indexOf(v) > -1; })) return false;

    if (skip !== 'price') {
      if (st.price.length) {
        var inBand = st.price.some(function (b) {
          var p = b.split('-');
          var lo = p[0] ? parseInt(p[0], 10) * 100 : 0;
          var hi = p[1] ? parseInt(p[1], 10) * 100 : Infinity;
          return c.p >= lo && c.p < hi;
        });
        if (!inBand) return false;
      }
      /* The typed range is ANDed on top of the preset bands, not OR'd - a
         customer who ticks a band and then types a narrower max means both. */
      if (st.min && c.p < parseInt(st.min, 10) * 100) return false;
      if (st.max && c.p > parseInt(st.max, 10) * 100) return false;
    }

    if (skip !== 'rating' && st.rating.length) {
      /* OR of ">=4.5" and ">=4" is just ">=4", so the loosest threshold wins. */
      var need = Math.min.apply(null, st.rating.map(parseFloat));
      if (c.r === null || c.r < need) return false;
    }

    if (skip !== 'time' && st.time.length) {
      var inTime = st.time.some(function (b) {
        if (c.m === null) return false;
        var p = b.split('-');
        var lo = p[0] ? parseInt(p[0], 10) : 0;
        var hi = p[1] ? parseInt(p[1], 10) : Infinity;
        return c.m >= lo && c.m <= hi;
      });
      if (!inTime) return false;
    }

    if (skip !== 'stock' && st.stock.length && !c.a) return false;
    if (skip !== 'sale' && st.sale.length && !c.s) return false;
    return true;
  }

  /* The "Price" legend hint was in the markup from day one but nothing ever
     wrote to it, so it rendered as a permanently empty slot. Liquid now
     server-renders the collection's true bounds into it; this narrows that to
     the range of what is actually on screen, which is the number a customer
     needs when several other facets are already on. Falls back to the full
     collection bounds when nothing matches, because "₹0 - ₹0" is worse than
     no update at all. */
  function kfPriceHint(matched) {
    var hint = document.querySelector('[data-kcf-price-hint]');
    var grp = document.querySelector('[data-kcf-group="price"]');
    if (!hint || !grp) return;
    var lo = parseInt(grp.getAttribute('data-kcf-price-lo'), 10);
    var hi = parseInt(grp.getAttribute('data-kcf-price-hi'), 10);
    if (isNaN(lo) || isNaN(hi) || hi <= 0) return;
    if (matched.length) {
      /* Cells stamp product.price in MINOR units (cents); kf_min/kf_max are in
         MAJOR units, which is why the /100 below is here and why these are
         formatted with formatMajor rather than format.
         Floor the low end and ceil the high one so a displayed bound can never
         exclude the product it came from. */
      var ps = matched.map(function (c) { return c.p; });
      lo = Math.floor(Math.min.apply(null, ps) / 100);
      hi = Math.ceil(Math.max.apply(null, ps) / 100);
    }
    /* lo/hi were divided by 100 above, so these are MAJOR units. */
    var fmt = function (n) { return window.KitstersMoney.formatMajor(n); };
    hint.textContent = lo === hi ? fmt(lo) : fmt(lo) + ' - ' + fmt(hi);
  }

  function kfRenderChips(matched) {
    var wrap = document.querySelector('[data-kcf-chips]');
    if (!wrap) return;
    var chips = [];
    KF_GROUPS.concat(KF_FLAGS).forEach(function (g) {
      (kfState[g] || []).forEach(function (v) {
        var input = document.querySelector('.kcf__input[name="' + g + '"][value="' + v + '"]');
        var lbl = KF_LABELS[v];
        if (!lbl && input) {
          var el = input.parentNode.querySelector('.kcf__pill-label, .kcf__switch-label');
          lbl = el ? el.textContent.trim() : v;
        }
        chips.push({ g: g, v: v, label: lbl || v });
      });
    });
    if (kfState.min || kfState.max) {
      chips.push({
        g: 'range', v: '',
        /* `max` may legitimately be the word "any", which is not a number and
           must not be run through the formatter. */
        label: window.KitstersMoney.formatMajor(kfState.min || 0) + ' - ' +
               (kfState.max ? window.KitstersMoney.formatMajor(kfState.max) : 'any')
      });
    }
    if (!chips.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    var html = chips.map(function (c) {
      return '<button type="button" class="kc__chip" data-kcf-chip data-g="' + c.g +
        '" data-v="' + c.v + '" aria-label="Remove filter: ' + c.label + '">' + c.label +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
        '<path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>';
    }).join('');
    if (chips.length > 1) {
      html += '<button type="button" class="kc__chip kc__chip--clear" data-kcf-clear>Clear all</button>';
    }
    wrap.innerHTML = html;
    wrap.hidden = false;
  }

  function kfApply(resetReveal) {
    var grid = kfGrid();
    if (!grid || !kfState) return;
    kfApplying = true;

    var cells = [].slice.call(grid.querySelectorAll('[data-kc-cell]')).map(kfCell);
    var batch = kfBatch();
    if (resetReveal || !kfShown) kfShown = batch;

    /* Sync every control from state, not the other way round - after a sort
       re-render the drawer markup is brand new and its checkboxes are blank,
       so state has to be able to rebuild the UI on its own. */
    [].forEach.call(document.querySelectorAll('.kcf__input'), function (i) {
      i.checked = (kfState[i.name] || []).indexOf(i.value) > -1;
    });
    var minI = document.querySelector('[data-kcf-min]');
    var maxI = document.querySelector('[data-kcf-max]');
    if (minI && document.activeElement !== minI) minI.value = kfState.min;
    if (maxI && document.activeElement !== maxI) maxI.value = kfState.max;

    var matched = cells.filter(function (c) { return kfMatch(c, null); });

    var revealed = 0;
    cells.forEach(function (c) {
      var hit = matched.indexOf(c) > -1;
      if (!hit) {
        c.el.setAttribute('data-kc-off', '');
        c.el.setAttribute('data-kc-over', '');
        return;
      }
      c.el.removeAttribute('data-kc-off');
      if (revealed < kfShown) { c.el.removeAttribute('data-kc-over'); revealed++; }
      else c.el.setAttribute('data-kc-over', '');
    });

    /* Per-option counts: how many products you'd have if this option were the
       only change. An option is hidden when ticking it could not change what the
       customer is looking at - either because nothing matches it (n === 0) or
       because EVERYTHING already does.

       The "everything already does" half compares against the count with this
       option's own group cleared, not against the whole collection: that is the
       real question ("would ticking this narrow anything?"), and it is stable
       while other filters are applied. Comparing against cells.length instead
       would make an option vanish with no filters on and reappear the moment an
       unrelated filter narrowed the set, which reads as the drawer glitching.

       Measured 2026-09-08, which is why this exists: "In stock" matched every
       product on all 19 collection pages, so it rendered a switch that could
       never change the grid; "Kit type" collapsed to a single option matching
       the whole collection on 5 of them, and "4 stars & up" on 3 more.

       A currently-ticked option always stays visible - hiding a control the
       customer just used would strand them with a filter they cannot see or
       clear. */
    var kfBase = {};
    [].forEach.call(document.querySelectorAll('.kcf__input'), function (i) {
      var g = i.name;
      if (!(g in kfBase)) {
        kfBase[g] = cells.filter(function (c) { return kfMatch(c, g); }).length;
      }
      var saved = kfState[g];
      kfState[g] = [i.value];
      var n = cells.filter(function (c) { return kfMatch(c, null); }).length;
      kfState[g] = saved;
      var opt = i.closest('[data-kcf-opt]');
      var badge = opt && opt.querySelector('[data-kcf-count]');
      if (badge) badge.textContent = n ? n : '';
      if (opt) opt.hidden = !i.checked && (n === 0 || n === kfBase[g]);
    });
    /* A group whose every option is hidden is noise - drop the whole block. */
    [].forEach.call(document.querySelectorAll('.kcf__group'), function (grp) {
      if (grp.getAttribute('data-kcf-group') === 'price') return;
      var any = [].some.call(grp.querySelectorAll('[data-kcf-opt]'), function (o) { return !o.hidden; });
      grp.hidden = !any;
    });
    /* ...and a drawer whose every group is gone is a button that opens an empty
       panel. The price group is never hidden above, so it is tested here on its
       own terms: a collection where every product costs the same has nothing to
       filter on at all. */
    var kfLiveGroups = [].filter.call(document.querySelectorAll('.kcf__group'), function (grp) {
      if (grp.getAttribute('data-kcf-group') !== 'price') return !grp.hidden;
      return [].some.call(grp.querySelectorAll('[data-kcf-opt]'), function (o) { return !o.hidden; });
    }).length;
    var kfBtn = document.querySelector('[data-kcf-open]');
    if (kfBtn) kfBtn.hidden = kfLiveGroups === 0;

    var total = cells.length;
    var bar = document.querySelector('[data-kcf-countbar]');
    if (bar) {
      bar.innerHTML = matched.length === total
        ? '<strong>' + total + '</strong> item' + (total === 1 ? '' : 's')
        : '<strong>' + matched.length + '</strong> of ' + total + ' items';
    }

    var badgeEl = document.querySelector('[data-kcf-badge]');
    var n = kfActiveCount();
    if (badgeEl) { badgeEl.textContent = n; badgeEl.hidden = n === 0; }
    var openBtn = document.querySelector('[data-kcf-open]');
    if (openBtn) openBtn.setAttribute('aria-label', n ? 'Open filters (' + n + ' active)' : 'Open filters');

    var applyTxt = document.querySelector('[data-kcf-apply-text]');
    if (applyTxt) {
      applyTxt.textContent = matched.length === total
        ? 'Show all ' + total + ' kits'
        : (matched.length === 0 ? 'No matches' : 'Show ' + matched.length + ' kit' + (matched.length === 1 ? '' : 's'));
    }

    var empty = document.querySelector('[data-kcf-empty]');
    if (empty) empty.hidden = matched.length !== 0;

    var more = document.querySelector('[data-kcf-more]');
    if (more) more.hidden = matched.length <= kfShown;

    kfPriceHint(matched);
    kfRenderChips(matched);
    kfWriteUrl();
    kfApplying = false;
  }

  /* ── Drawer open/close ─────────────────────────────────────────────── */
  var kfLastFocus = null;

  function kfOpen() {
    var d = document.querySelector('[data-kcf]');
    if (!d) return;
    kfLastFocus = document.activeElement;
    d.hidden = false;
    /* Next frame so the transition has a from-state to animate out of. */
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('kcf-lock');
    var btn = document.querySelector('[data-kcf-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var close = d.querySelector('[data-kcf-close]');
    if (close) close.focus();
  }

  function kfClose() {
    var d = document.querySelector('[data-kcf]');
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('kcf-lock');
    var btn = document.querySelector('[data-kcf-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    /* Wait out the slide-out before hiding, or it vanishes instead of closing. */
    window.setTimeout(function () { d.hidden = true; }, 220);
    /* Send focus back where it came from - but only if that is still a real,
       focusable element in the document. A programmatic open (or a click, which
       does not focus a <button> in every browser) leaves activeElement as
       <body>, and restoring to <body> strands a keyboard user at the top of the
       page instead of on the control they just used. Fall back to the trigger. */
    var target = kfLastFocus;
    if (!target || target === document.body || !target.isConnected || !target.focus) {
      target = btn;
    }
    if (target && target.focus) target.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-kcf-open]')) { kfOpen(); return; }
    if (e.target.closest('[data-kcf-close]') || e.target.closest('[data-kcf-scrim]') ||
        e.target.closest('[data-kcf-apply]')) { kfClose(); return; }

    var clear = e.target.closest('[data-kcf-clear]');
    if (clear) {
      KF_GROUPS.concat(KF_FLAGS).forEach(function (g) { kfState[g] = []; });
      kfState.min = ''; kfState.max = '';
      kfApply(true);
      return;
    }

    var chip = e.target.closest('[data-kcf-chip]');
    if (chip) {
      var g = chip.getAttribute('data-g');
      if (g === 'range') { kfState.min = ''; kfState.max = ''; }
      else {
        var v = chip.getAttribute('data-v');
        kfState[g] = (kfState[g] || []).filter(function (x) { return x !== v; });
      }
      kfApply(true);
      return;
    }

    if (e.target.closest('[data-kcf-more-btn]')) {
      kfShown += kfBatch();
      kfApply(false);
      var more = document.querySelector('[data-kcf-more-btn]');
      if (more && !more.closest('[data-kcf-more]').hidden) more.focus();
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var i = e.target.closest ? e.target.closest('.kcf__input') : null;
    if (!i || kfApplying) return;
    var g = i.name;
    var set = (kfState[g] || []).filter(function (x) { return x !== i.value; });
    if (i.checked) set.push(i.value);
    kfState[g] = set;
    kfApply(true);
  });

  var kfPriceTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    var isMin = e.target.closest('[data-kcf-min]');
    var isMax = e.target.closest('[data-kcf-max]');
    if (!isMin && !isMax || kfApplying) return;
    clearTimeout(kfPriceTimer);
    kfPriceTimer = setTimeout(function () {
      var mn = document.querySelector('[data-kcf-min]');
      var mx = document.querySelector('[data-kcf-max]');
      kfState.min = mn && mn.value ? String(Math.max(0, parseInt(mn.value, 10) || 0)) : '';
      kfState.max = mx && mx.value ? String(Math.max(0, parseInt(mx.value, 10) || 0)) : '';
      kfApply(true);
    }, 280);
  });

  document.addEventListener('keydown', function (e) {
    var d = document.querySelector('[data-kcf]');
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { kfClose(); return; }
    if (e.key !== 'Tab') return;
    /* Focus trap - a modal that lets focus wander behind the scrim is not one. */
    var f = d.querySelectorAll('button, input, [href], select, [tabindex]:not([tabindex="-1"])');
    var vis = [].filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('popstate', function () {
    if (!kfGrid()) return;
    kfState = kfReadUrl();
    kfApply(true);
  });

  function kfInit() {
    if (!kfGrid()) return;
    kfState = kfReadUrl();
    kfApply(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kfInit);
  else kfInit();

  /* The sort control re-renders [main-content] through the Section Rendering
     API, which throws away the grid, the drawer and the chips. Watching the
     section for that swap re-applies the active filters afterwards, so sorting
     a filtered view doesn't silently show the whole collection again. Scoped to
     the section's direct children: everything this engine mutates is deeper
     than that, so it cannot retrigger itself. */
  var kfHost = document.querySelector('.kc');
  if (kfHost && window.MutationObserver) {
    new MutationObserver(function () {
      if (kfApplying || !kfGrid()) return;
      kfState = kfReadUrl();
      kfApply(true);
    }).observe(kfHost, { childList: true });
  }
  /* ── KS-23 · FAQ accordion: collapse on phones ──────────────────────────
     The panels are served with `open` set, so the raw HTML is fully expanded:
     that is the state a crawler and an answer engine read, and it is also the
     no-JS state, which matters because this is the only thing here that is not
     progressive enhancement.

     Below 768px six expanded answers push the footer several screens down, so
     all but the first are closed on load. Deliberately NOT bound to a resize
     or a matchMedia change listener: after first paint the open/closed state
     belongs to the reader, and reflowing it under them when a phone rotates
     would throw away a panel they had just opened.

     `kcqDone` guards against the Section Rendering API swap — the sort control
     re-renders [main-content], and the MutationObserver at the foot of this
     file fires on that. The FAQ is outside [main-content] and so survives the
     swap untouched; re-running here would re-collapse panels the reader had
     opened, for a change that never touched them. */
  function kcqCollapseOnMobile() {
    var list = document.querySelector('[data-kcq-list]');
    if (!list || list.dataset.kcqDone === '1') return;
    list.dataset.kcqDone = '1';
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) return;
    var items = list.querySelectorAll('.kcq__item');
    for (var i = 1; i < items.length; i++) items[i].removeAttribute('open');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kcqCollapseOnMobile);
  } else {
    kcqCollapseOnMobile();
  }

})();
